module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "part-num"
  }, [_vm._v("Part I")]), _vm._v(" "), _c('p', {
    staticClass: "part-hd"
  }, [_vm._v("WHEREVER BUSINESS COULD BE HAD")]), _vm._v(" "), _c('div', {
    staticClass: "image-break"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/Page19.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Crowded sidewalk shoppers waiting for Auerbach’s doors to open. "), _c('i', [_vm._v("Special Collections, Marriott Library, University of Utah")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23b21a1c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/part1.vue
// module id = 81
// module chunks = 0